import { useIntl } from 'react-intl'
import { CruiseType } from 'constants/cruise'
import { useQsQueryParams } from 'hooks/useQueryParams'

export default function useCruiseSelectedCabinType(cruiseType?: App.CruiseType) {
  const intl = useIntl()
  const { cabinTypes } = useQsQueryParams<{ cabinTypes?: string }>()

  if (cabinTypes && cabinTypes.length > 1 && cabinTypes.includes('Oceanview') && cabinTypes.includes('Window')) {
    if (cruiseType && cruiseType === CruiseType.RIVER) {
      return intl.formatMessage({
        id: 'mlVCDBEOUUkTL5zDHLsd',
        defaultMessage: 'Window',
        description: 'Cruise cabin type label for river cruise window cabins',
      })
    } else if (cruiseType && cruiseType === CruiseType.OCEAN) {
      return intl.formatMessage({
        id: 'G3QBGNy3vexP9SHAzo1I',
        defaultMessage: 'Oceanview',
        description: 'Cruise cabin type label for ocean cruise oceanview cabins',
      })
    }

    return intl.formatMessage({
      id: 'JqAllf0-m3rd_YW3QHNN',
      defaultMessage: 'Oceanview / Window',
      description: 'Cruise cabin type label when both oceanview and window cabins are selected',
    })
  }

  return cabinTypes
}
